import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { BaseComponent } from '../../base-components/base.component';

@Component({
    selector: 'json-viewer',
    templateUrl: './json-viewer.html',
    inputs: ['json', 'jsonObject', 'includeTextBox', 'includeHeaders']
})

/**
 * Displays a non-technical view of JSON
*/
export class JsonViewerComponent extends BaseComponent {
    public json = '';
    public jsonObject: any;
    public includeTextBox = true;
    public includeHeaders = true;
    public nodes: TreeNode[] = [];

    constructor() {
        super();
    }

    public ngOnInit() {}

    public ngOnChanges() {
        this.setNodes();
    }

    public setNodes() {
        if (this.json || this.jsonObject) {
            let obj = this.jsonObject || JSON.parse(this.json);
            this.nodes = [];
            if (Array.isArray(obj)) {
                for (let [subKey, subValue] of Object.entries(obj)) {
                    this.nodes.push(this.parseNode(subKey, subValue));
                }
            } else {
                this.nodes.push(this.parseNode('Root', obj));
                this.nodes[0].expanded = true;
            }
        }
    }

    private parseNode(key: string, value: any): TreeNode {
        let treeNode: TreeNode = {};
        treeNode.label = key;
        treeNode.data = value;
        if (this.isPrimativeOrNullOrEmpty(value)) {
            treeNode.label += ': ' + this.stringValue(value);
        } else {
            treeNode.children = [];
            for (let [subKey, subValue] of Object.entries(value)) {
                treeNode.children.push(this.parseNode(subKey, subValue));
            }
        }
        return treeNode;
    }

    private stringValue(value: any): string {
        return Array.isArray(value) ? 'Empty' : value;
    }

    private isPrimativeOrNullOrEmpty(value: any): boolean {
        return !value || typeof (value) !== 'object' || (Array.isArray(value) && !value.length);
    }

}
